<div style="display: flex; flex-direction: column; min-height: 100vh;">
  <rh-standalone-newsletter-header *ngIf="('MOBILE' | isViewMode | async) === false" class="bg-white"></rh-standalone-newsletter-header>
  <rh-header-mobile *ngIf="('MOBILE' | isViewMode | async) === true"></rh-header-mobile>

  <div class="layout">
		<rh-desktop-only-warning *ngIf="(showOnlyDesktopWarning$ | async) == true"></rh-desktop-only-warning>
		<div
			class="main lpb-8"
			[class.mobile]="'MOBILE' | isViewMode | async"
			[class.allow-to-show-banner-mobile]="('MOBILE' | isViewMode | async) && (allowToShow$ | async) === true"
			[class.hide]="(showOnlyDesktopWarning$ | async) == true"
      [class.banner-visible]="(allowToShow$ | async) === true"
		>
			<router-outlet></router-outlet>
		</div>
		<rh-development-helpers *atrIfEnvironment="'dev'"></rh-development-helpers>
	</div>
	<rh-footer class="no-print"></rh-footer>
</div>
